import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { removeWorkingAreaWarning } from '@app/actions/customizeActions';

import HelpTip from '@components/help/help-tip/HelpTip';
import './WorkingAreaWarnings.scss';

const WorkingAreaWarnings = ({ workingAreaWarnings, removeWorkingAreaWarning, toolPanelExpanded }) => {
  const warningsToShow = useMemo(() => workingAreaWarnings.slice(0, 2), [workingAreaWarnings]);
  const warningsExist = useMemo(() => !!warningsToShow.length, [warningsToShow]);

  return warningsExist ? (
    <div id="qau-working-area-warnings-container" className={classnames({ 'toolpanel-expanded': toolPanelExpanded })}>
      {warningsToShow.map(({ key: locKey, helpSection, helpTopic, onRemove }, i) => (
        <HelpTip
          key={locKey}
          onClick={() => {
            removeWorkingAreaWarning(locKey);
            onRemove?.();
          }}
          helpSection={helpSection}
          helpTopic={helpTopic}
          tipLocKey={locKey}
        />
      ))}
    </div>
  ) : null;
};

const mapStateToProps = ({
  customize: {
    customizeData: { workingAreaWarnings, toolPanelOverlayLayout },
  },
}) => ({ workingAreaWarnings, toolPanelExpanded: !!toolPanelOverlayLayout });

const mapDispatchToProps = {
  removeWorkingAreaWarning,
};

WorkingAreaWarnings.propTypes = {
  toolPanelExpanded: PropTypes.bool.isRequired,
  workingAreaWarnings: PropTypes.array.isRequired,
  removeWorkingAreaWarning: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkingAreaWarnings);
